import { Timezone } from '@/components/molecules/main-header/types';
import { Location, Logo } from '@/entities/League';

export interface NextEventGamedayLocation extends Location {
	streetAddress: string;
	venue: string;
}

export enum BANNER_TYPE {
	SCHEDULE_EVENT = 'BANNER_TYPE_SCHEDULE_EVENT',
	GAMEDAY = 'BANNER_TYPE_GAME_DAY'
}

export interface NextEventGameday {
	uuid: string;
	title: string | null;
	startDate: string;
	endDate: string;
	logo: Logo | null;
	location: NextEventGamedayLocation;
	timezone: Timezone;
	bannerType: BANNER_TYPE;
}
